import { render, staticRenderFns } from "./CragPageHeader.vue?vue&type=template&id=381c80c8"
import script from "./CragPageHeader.vue?vue&type=script&lang=js"
export * from "./CragPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports